// src/features/auth/authSlice.js

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    getUser: (state) => {
      return state.user
    },
    setUser: (state, action) => {
      state.user = action.payload
    }
  }
})

export const { getUser, setUser } = authSlice.actions

export default authSlice.reducer
